import TIM from 'tim-js-sdk/tim-js-friendship.js'
import TIMUploadPlugin from 'tim-upload-plugin'

// 1. 初始化 SDK 实例

const tim = TIM.create({
  SDKAppID: 1400793445
})




window.setLogLevel = tim.setLogLevel

// 无日志级别
tim.setLogLevel(4)

// 注册 cos
tim.registerPlugin({ 'tim-upload-plugin':TIMUploadPlugin })
console.log("tim",tim)
export default tim



// WEBPACK FOOTER //
// ./src/tim.js